import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { MyDispatch, MySelector } from "../redux/store"
import { setAppTheme } from "../redux/themeSlice"
import { parseGalleryTheme } from "../gallery-designs/registry"

const useTheme = () => {
  const dispatch = useDispatch<MyDispatch>()
  const { data: eventData } = MySelector((state) => state.event)

  // Color mode is the suffix of eventData.galleryTheme (e.g. "...-dark"),
  // so it stays in sync with the design selected from the same value.
  const galleryTheme =
    eventData && eventData !== "null" ? eventData?.galleryTheme : undefined
  const { mode: theme } = parseGalleryTheme(galleryTheme)

  useEffect(() => {
    dispatch(setAppTheme(theme))
    document.body.classList.remove("light", "dark")
    document.body.classList.add(theme)
  }, [theme, dispatch])

  return { theme }
}

export default useTheme
